import { Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';


const FieldDescriptionTable = ({ fields, title = "Field Descriptions" }) => {
    const getTypeColor = (type) => {
        const colors = {
            'string': { bg: '#dcfce7', text: '#166534' },
            'boolean': { bg: '#fef3c7', text: '#b45309' },
            'integer': { bg: '#dbeafe', text: '#1e40af' },
            'long': { bg: '#dbeafe', text: '#1e40af' },
            'datetime': { bg: '#e9d5ff', text: '#6b21a8' },
            'object': { bg: '#fed7aa', text: '#92400e' },
            'array': { bg: '#cffafe', text: '#164e63' }
        };
        return colors[type] || { bg: '#f3f4f6', text: '#374151' };
    };

    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                variant="h6"
                sx={{
                    mb: 2,
                    fontWeight: 700,
                    color: '#1f2937',
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <Box sx={{ width: 4, height: 4, backgroundColor: '#3b82f6', borderRadius: '2px' }} />
                {title}
            </Typography>

            <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    overflow: 'hidden'
                }}
            >
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f9fafb' }}>
                            <TableCell sx={{ fontWeight: 700, color: '#374151', fontSize: '0.85rem' }}>
                                Field Name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#374151', fontSize: '0.85rem' }}>
                                Type
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#374151', fontSize: '0.85rem' }}>
                                Required
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#374151', fontSize: '0.85rem' }}>
                                Description
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fields.map((field, index) => {
                            const typeStyle = getTypeColor(field.type);
                            return (
                                <TableRow
                                    key={index}
                                    hover
                                    sx={{
                                        '&:hover': { backgroundColor: '#f9fafb' },
                                        borderBottom: '1px solid #f3f4f6'
                                    }}
                                >
                                    <TableCell>
                                        <Box
                                            sx={{
                                                fontFamily: '"Fira Code", monospace',
                                                fontWeight: 600,
                                                color: '#1f2937',
                                                fontSize: '0.9rem'
                                            }}
                                        >
                                            {field.field}
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={field.type}
                                            size="small"
                                            sx={{
                                                backgroundColor: typeStyle.bg,
                                                color: typeStyle.text,
                                                fontWeight: 600,
                                                fontSize: '0.75rem',
                                                height: '24px'
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={field.required ? 'Required' : 'Optional'}
                                            size="small"
                                            sx={{
                                                backgroundColor: field.required ? '#fee2e2' : '#f3f4f6',
                                                color: field.required ? '#991b1b' : '#6b7280',
                                                fontWeight: 600,
                                                fontSize: '0.75rem',
                                                height: '24px'
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" sx={{ color: '#4b5563', fontSize: '0.9rem' }}>
                                            {field.description}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};
export default FieldDescriptionTable;